import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';
import { REPORT_TYPES } from './consts';
import { dateFormatterForUS } from '../../../utils/formatHelper';

export function RlrsTableRow(props) {
  const { row } = props;
  const { visibleColumns } = useSelector((state) => state.analytics.reports[REPORT_TYPES.RLRS]);
  const isOpen = row.rlrWasProcessed !== true;

  return (
    <tr>
      <td>{dateFormatterForUS(row.rlrCreatedDate)}</td>
      <td>{row.rlrIdInSource ?? NO_VALUE_PLACEHOLDER}</td>
      <td>{dateFormatterForUS(row.orderCreatedDate)}</td>
      <td>{row.retailerName}</td>
      <td>{row.countryName}</td>
      <td>{row.retailerOrderId}</td>
      <td>{isOpen ? 'Yes' : 'No'}</td>
      {visibleColumns.includes('salesOrderNumber') && <td>{row.salesOrderNumber}</td>}
      {visibleColumns.includes('sku') && <td>{row.identifiers.sku ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('upc') && <td>{row.identifiers.upc ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('ean') && <td>{row.identifiers.ean ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('model') && <td>{row.model}</td>}
      {visibleColumns.includes('productName') && <td>{row.productName}</td>}
      {visibleColumns.includes('rlrUnits') && <td>{row.rlrUnits}</td>}
      {visibleColumns.includes('fulfillmentId') && <td>{row.fulfillmentId ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('fulfillmentIdInSource') && <td>{row.fulfillmentIdInSource ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('rlrTrackingNumber') && <td>{row.rlrTrackingNumber ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('rlrReasonType') && <td>{row.rlrReasonType ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('rlrReasonText') && <td>{row.rlrReasonText ?? NO_VALUE_PLACEHOLDER}</td>}
    </tr>
  );
}

RlrsTableRow.propTypes = {
  row: PropTypes.object.isRequired,
};
